import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack } from "@mui/material";
import { ButtonComponent } from "../form";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';

const DialogComponent = ({
    open,
    title="",
    body,
    fullScreen=false,
    handleClose,
    disableBackdropClose=false,
    proceedText="Yes",
    proceedCallback=null,
    proceedActionLoading=false,
    disableProceed=false,
    cancelText="No",
    cancelCallback=null,
    disableCancel=false,
    closeCallback=null,
    hideAction=false,
    size="md",
    ...other
}) => {
    return (
        <>
            <React.Fragment>
                <Dialog
                    fullScreen={fullScreen}
                    open={open}
                    onClose={disableBackdropClose ? ()=>{} : handleClose}
                    aria-labelledby="responsive-dialog-title"
                    maxWidth={size}
                    
                    {...other}
                >
                    <DialogTitle id="responsive-dialog-title">
                        <Stack
                            direction='row'
                            justifyContent='space-between'
                            alignItems='center'
                        >
                            {title}

                            {
                                closeCallback
                                ?
                                <IconButton onClick={closeCallback}>
                                    <CloseIcon />
                                </IconButton>
                                :
                                <></>
                            }
                        </Stack>
                    </DialogTitle>

                    <DialogContent
                        sx={{
                            /* Hide scrollbar for Chrome, Safari and Opera */
                            '&::-webkit-scrollbar': {
                                display: 'none',
                            },
                            /* Hide scrollbar for IE, Edge and Firefox */
                            msOverflowStyle: 'none',
                            scrollbarWidth: 'none'
                        }}
                    >
                        {body}
                    </DialogContent>

                    <DialogActions 
                        sx={{
                            pb: 3, 
                            pr: 3,
                            display: hideAction ? 'none' : 'flex'
                        }}
                    >
                        {
                            cancelCallback
                            ?
                            <ButtonComponent 
                                variant="text"
                                label={cancelText}
                                onClick={cancelCallback}
                                disabled={disableCancel}
                            />
                            :
                            <ButtonComponent 
                                variant="text"
                                label={cancelText}
                                onClick={handleClose}
                                disabled={disableCancel}
                            />
                        }
                        
                        {
                            proceedCallback
                            ?
                            <ButtonComponent 
                                label={proceedText}
                                onClick={proceedCallback}
                                inLoading={proceedActionLoading}
                                disabled={disableProceed}
                            />
                            :
                            <></>
                        }
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        </>
    );
}

export default DialogComponent;